/* eslint-disable react/react-in-jsx-scope */
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const QuillRichTextEditor = ({ value, changeFn }) => {
  // Quill modules configuration
  const modules = {
    toolbar: [
      [{ header: '1' }, { header: '2' }, { font: [] }],
      [{ size: [] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
      ['link', 'image', 'video'],
      ['clean'],
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
  };

  return (
    <div>
      <ReactQuill
        className="h-[10rem]"
        theme="snow"
        formats={[
          'header',
          'font',
          'size',
          'bold',
          'italic',
          'underline',
          'strike',
          'blockquote',
          'list',
          'bullet',
          'indent',
          'link',
          'image',
          'video',
        ]}
        placeholder="Write something amazing..."
        modules={modules}
        onChange={changeFn} // Handle text editor content changes
        value={value} // Set the value of the text editor in content
      />
    </div>
  );
};

export default QuillRichTextEditor;
